import React from 'react';

import { TextBlock } from '@components/TextBlock';

import { GradeIcon, PeriodIcon, ProgramIcon, FieldIcon } from '@assets/icons';

import { EEducationIcons } from '@enum';

import {
  CLIconContainer,
  CLTextContainer,
  CharacteristicContainer,
} from './CharacteristicLine.styled';

import { CharacteristicLineProps } from './CharacteristicLine.types';

const getIcon = (icon: EEducationIcons) => {
  switch (icon) {
    case EEducationIcons.period:
      return <PeriodIcon />;
    case EEducationIcons.program:
      return <ProgramIcon />;
    case EEducationIcons.grade:
      return <GradeIcon />;
    default:
      return <FieldIcon />;
  }
};

export const CharacteristicLine = ({
  text,
  textColor,
  icon = EEducationIcons.field,
}: CharacteristicLineProps) => (
  <CharacteristicContainer>
    <CLIconContainer textColor={textColor}>{getIcon(icon)}</CLIconContainer>
    <CLTextContainer>
      <TextBlock text={text} align="left" color={textColor} />
    </CLTextContainer>
  </CharacteristicContainer>
);
